define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerEmployeeModel = /** @class */ (function () {
        function CustomerEmployeeModel(data) {
            this.Id = ko.observable(0);
            this.CustomerId = ko.observable(0);
            this.EmployeeId = ko.observable();
            this.EmployeeRoleId = ko.observable();
            this.CommissionRoleId = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerEmployeeModel.Mapping, self);
            }
        }
        CustomerEmployeeModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerEmployeeModel(options.data);
            }
        };
        return CustomerEmployeeModel;
    }());
    return CustomerEmployeeModel;
});
//# sourceMappingURL=CustomerEmployeeModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerEmployeeModel.js
// module id = 170
// module chunks = 2